import axios from 'axios';
// import moment from "moment";
// import {downloadFile} from "@/helpers/helpers";
import {getField, updateField} from 'vuex-map-fields';

const getDefaultState = () => {
    return {
        paymentsHistory: [],
        wallet: null,
        invoices: null,
    }
}

export const state = getDefaultState();

export const getters = {
    getField
}

export const actions = {
    async fetch({commit}) {
        const response = await axios.get(`/fastmarket/account/credit`);
        commit('SET_PAYMENT_HISTORY', response.data);
    },
    async wallet({commit}) {
        const response = await axios.get(`/fastmarket/account/credit/wallet`);
        commit('SET_WALLET', response.data);
    },
    async invoices({commit}) {
        const response = await axios.get(`/fastmarket/account/invoices`);
        commit('SET_INVOICES', response.data);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async addPayment({commit}, info) {
        let data = new FormData();
        data.append("amount", info.amount);
        data.append("cart_id", info.cart_id);
        data.append("voucher", info.voucher.dataUrl);
        data.append("namefile", info.voucher.info.name);
        const response = await axios.post(`/fastmarket/account/credit/addPayment`, data);
        return response.data.success
    },
    async deletePayment({commit}, id) {
        const response = await axios.delete(`/fastmarket/account/credit/${id}/deletePayment`);
        return response.data.success
    },
}

export const mutations = {
    updateField,
    SET_PAYMENT_HISTORY(state, result) {
        state.paymentsHistory = result
    },
    SET_WALLET(state, result) {
        state.wallet = result
    },
    SET_INVOICES(state, result) {
        state.invoices = result.data
    },
}